<template>
	<v-container fluid>
		<Calculadora ref="refCalculadora" :emisor="emisor"/>
	</v-container>
</template>
<script>

import Calculadora from '@/views/Calculadora.vue';
import { mapGetters } from 'vuex'

export default {
	components:{
		Calculadora
	},
	computed:{
		...mapGetters({
			emisor: 'empresas/seleccionada'
		})
	},
	async mounted(){
		let cookies = document.cookie
		// alert(cookies)
		// await this.$nextTick()
		// this.$refs.refCalculadora.cargarDatosEmisor()
		console.log('this.$store', this.$store)
		
	}
}

</script>